export const GET_ADDRESS_PREDICTIONS = 'GET_ADDRESS_PREDICTIONS'
export const GET_ADDRESS_PREDICTIONS_SUCCESS = 'GET_ADDRESS_PREDICTIONS_SUCCESS'
export const GET_ADDRESS_PREDICTIONS_FAILURE = 'GET_ADDRESS_PREDICTIONS_FAILURE'

export const getAddressPredictions = (query, country) => ({
  type: GET_ADDRESS_PREDICTIONS,
  payload: { query, country },
})
